import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FIELD_TYPES } from '../../../../components/DynamicField/Tasks/utils/utils';
import { sortRows, sortRowsWithIds  } from '../dashboard-dynamic-fields-util';
import DashboardDynamicFieldsTableBody from './dashboard-dynamic-fields-table-body';
import DashboardDynamicFieldsTableHeader from './dashboard-dynamic-fields-table-header';

export const SORT_DIRECTIONS = {
    NONE: -1,
    UP: 1,
    DOWN: 2,
};

const DashboardDynamicFieldsTable = ({
    isModal,
    columns,
    rowsRolledOver,
    rows,
    enableRowModal,
    dynamicFieldsForRowModal,
    rowIds,
    isAdmin,
    isStaffer,
    ProjectTypeId,
    TaskTypeId,
    fetchData,
}) => {
    const [sortDirection, setSortDirection] = useState(SORT_DIRECTIONS.NONE);
    const [sortColumnIdx, setSortColumnIdx] = useState(SORT_DIRECTIONS.NONE);
    const [fieldType, setFieldType] = useState(FIELD_TYPES.time);

    // Set default sort to "Last Updated" column (last column, sorted descending)
    useEffect(() => {
        if (columns && columns.length > 0 && sortColumnIdx === SORT_DIRECTIONS.NONE) {
            const lastColumnIdx = columns.length - 1;
            setSortColumnIdx(lastColumnIdx);
            setSortDirection(SORT_DIRECTIONS.UP); // UP = descending (most recent first)
            setFieldType(FIELD_TYPES.date); // Last Updated is a date field
        }
    }, []);

    const headerProps = {
        isModal,
        isAdmin,
        isStaffer,
        columns: rows.length === 0 ? [] : columns,
        sortDirection,
        setSortDirection,
        sortColumnIdx,
        setSortColumnIdx,
        fieldType,
        setFieldType
    };

    const {
        sortedRows,
        sortedRowIds
    } = sortRowsWithIds({
        fieldType,
        sortColumnIdx,
        sortDirection,
        rows,
        rowIds,
    });

    const bodyProps = {
        isModal,
        rows: sortedRows,
        rowsRolledOver,
        enableRowModal,
        dynamicFieldsForRowModal,
        rowIds: sortedRowIds, // <-- keep these in sync now
        isAdmin,
        isStaffer,
    };

    return (
        <table className="projects-table stickyTable">
            <DashboardDynamicFieldsTableHeader {...headerProps} />
            <div className={`${isModal ? 'modal' : 'normal'}-project-table-inside`}>
                <div className={`scrollable ${isModal ? 'modal-height' : 'normal-height'}`}>
                    <DashboardDynamicFieldsTableBody
                        {...bodyProps}
                        isAdmin = {isAdmin}
                        isStaffer = {isStaffer}
                        ProjectTypeId = {ProjectTypeId}
                        TaskTypeId = {TaskTypeId}
                        fetchData={fetchData}
                    />
                </div>
            </div>
        </table>
    );
};

DashboardDynamicFieldsTable.propTypes = {
    isModal: PropTypes.bool,
    columns: PropTypes.array,
    rowsRolledOver: PropTypes.bool,
    rows: PropTypes.array,
    enableRowModal: PropTypes.bool,
    dynamicFieldsForRowModal: PropTypes.array,
    rowIds: PropTypes.array,
    isAdmin: PropTypes.bool,
    isStaffer: PropTypes.bool,
    ProjectTypeId: PropTypes.number,
    TaskTypeId: PropTypes.number,
    fetchData: PropTypes.func
};

export default DashboardDynamicFieldsTable;
